import { Check, CheckCircle, Circle } from '@phosphor-icons/react';
import React from 'react';
import EventCard from './eventCard';

const CheckListMenu = (props) => {
  const {
    eventData,
  } = props;

  return (
    <div className="pt-16 pb-5 px-4 md:px-20 md:border-r md:h-auto flex flex-col gap-12">
      <div className="flex flex-col gap-9">
        <div className="heading-36">
          Verify your identity to publish your event
        </div>

  <ul className="flex flex-col gap-5 text-18">
          <li className="flex gap-3">
            <span>
              <CheckCircle weight="fill"
                color="#FF2459"
                size={24} />
            </span>
            Listing created
          </li>
          <li className="flex gap-3">
            <span>
              <CheckCircle weight="fill"
                color="#FF2459"
                size={24} />
            </span>
            Phone number
          </li>
          <li className="flex gap-3">
            <span>
              <Circle weight="bold"
                color="#FF2459"
                size={24} />
            </span>
            Verify identity
          </li>
        </ul>
      </div>
      <div>
        <EventCard
          eventName={eventData.name}
          eventCity={eventData?.geo_location}
          eventDate={eventData.start_date}
          endDate={eventData?.end_date}
          url={eventData?.image}
          eventType={eventData?.type}
        />
      </div>
    </div>
  );
};

export default CheckListMenu;
